import React from 'react';
import moment from 'moment';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { translate, Trans } from 'react-i18next'
import OrganisationSelector from '../organisations/Selector';
import Toggle from '../forms/Toggle';
import styles from './visualmenu.scss'

import SignOutButton from '../containers/SignOutButton';

const labels = {
  0: '12:00',
  60: '13:00',
  120: '14:00',
  180: '15:00',
  240: '16:00',
  300: '17:00',
  360: '18:00',
  420: '19:00',
  480: '20:00',
  540: '21:00',
  600: '22:00',
  660: '23:00',
  720: '00:00',
  780: '01:00',
  840: '02:00',
  900: '03:00',
  960: '04:00',
  1020: '05:00',
  1080: '06:00',
  1140: '07:00',
  1200: '08:00',
  1260: '09:00',
  1320: '10:00',
  1380: '11:00',
  1440: '12:00'
}

const VisualMenu = ({ t, sunrise, sunset, sliderValue, onSliderChange, profileMode, onProfileModeChange }) => {
  let sunTimes = {};
  let gradient = {};
  if(sunrise && sunset) {
    let sunriseIndex = sunrise.getHours() > 12 ? (sunrise.getHours() - 12) * 60 : (sunrise.getHours() + 12) * 60 // 6
    let sunsetIndex = sunset.getHours() > 12 ? (sunset.getHours() - 12) * 60 : (sunset.getHours() + 12) * 60 // 6

    sunriseIndex += sunrise.getMinutes();
    sunsetIndex += sunset.getMinutes();

    sunTimes = {
      [sunriseIndex]: { label: `Sunrise: ${moment(sunrise).format("HH:mm")}`,
        style: {top: '-30px', width: '100px', transform: 'translateX(-25%)'}
      },
      [sunsetIndex]: { label: `Sunset: ${moment(sunset).format("HH:mm")}`,
        style: {top: '-30px', width: '100px', transform: 'translateX(-25%)'}
      },
    }
    const sunDown = sunsetIndex/1440 * 100;
    const sunUp = sunriseIndex/1440 * 100;
    if (sunriseIndex > sunsetIndex) {
      gradient = {
        background:'linear-gradient(to right, #f2ba21 0%,#f2ba21 ' + (sunDown-2) + '%,#00233f ' + (sunDown+2) + '%,#00233f ' + (sunUp-2) + '%,#f2ba21 ' + (sunUp+2) + '%,#f2ba21 100%)'
      }
    } else {
      gradient = {
        background:'linear-gradient(to right, #00233f 0%,#00233f ' + (sunUp-2) + '%,#f2ba21 ' + (sunUp+2) + '%,#f2ba21 ' + (sunDown-2) + '%,#00233f ' + (sunDown+2) + '%,#00233f 100%)'
      }
    }
  }

  return (
    <div className="visual-menu">
      <div className="slider-wrapper">
        <div className="slider-background" style={gradient}></div>
        <Slider
          min={0}
          max={1440}
          dots={true}
          step={15}
          marks={{ ...labels, ...sunTimes}}
          onChange={onSliderChange}
          defaultValue={sliderValue} />
      </div>
      <div className="visual-select-signout">
        <SignOutButton className="sign-out-btn" />
        <OrganisationSelector path="/visual" />
      </div>
      <div className="toggle-low-high-container">
        <div className="toggle-low-text">
          {t('LOW')}
        </div>
        <div className="toggle-low-high">
          <Toggle checked={profileMode === 'low' ? false : true} name={"als_mode_enabled"} onChange={onProfileModeChange} />
        </div>
        <div className="toggle-high-text">
          {t('HIGH')}
        </div>
      </div>
    </div>
  );
}

export default translate('profile')(VisualMenu);



// WEBPACK FOOTER //
// ./src/components/layout/VisualMenu.js